import React from "react";
import { Form } from "antd";
import Input from "./BaseInput";
import ShopDTO from "@/dto/shop/ShopDTO";
import ShopType from "@/enum/ShopType";
import { SupplierShopTypes } from "@/utils/ShopUtils";
import AutoDismissToolTip from "@/components/AutoDismissToolTip";

interface ConsigneeNameFieldProps {
    shop: ShopDTO;
}

const hideConsigneeNameShopTypes = [
    ShopType.PDD_FDS,
    ShopType.ALIBABA_SUPPLIER,
    ShopType.DOUDIAN_SUPPLIER,
    ShopType.PDD_FULFILLMENT,
    ShopType.YOUZAN,
    ...SupplierShopTypes,
];

const ConsigneeNameField: React.FC<ConsigneeNameFieldProps> = ({ shop }) => {
    if (hideConsigneeNameShopTypes.includes(shop.type)) return null;

    return (
        <AutoDismissToolTip
            trigger="click"
            title={
                <>
                    <p>1、淘宝，阿里，京东，拼多多，抖店等加密订单不能模糊搜索</p>
                    <p>2、其他平台模糊搜家请加上*号，如：周*或*杰伦</p>
                </>
            }
        >
            <Form.Item name="consigneeName" label={<span className="search-field-label">收货人</span>}>
                <Input placeholder="不能模糊搜索" />
            </Form.Item>
        </AutoDismissToolTip>
    );
};

export default React.memo(ConsigneeNameField);
